import FileShow from './FileShow'
export {FileShow}
export default FileShow
